import React, {useEffect, useState} from "react";
import leaderboardHeader from "../../../resources/leaderboardHeader.png";
import logoRoll from "../../../resources/logoRoll.png";
import logoLuxdrop from "../../../resources/luxdropLogo.png";
import logoHypedrop from "../../../resources/logoHypedrop.png";
import logoStake from "../../../resources/logoStake.png";
import logoCsbattle from "../../../resources/csbattle_logo.svg";
import logoCsgogem from "../../../resources/csgogem_logo.svg";
import {NavLink, Route, Routes, useLocation} from "react-router-dom";
import RollLeaderboard from "./RollLeaderboard";
import LuxdropLeaderboard from "./LuxdropLeaderboard";
import HypedropLeaderboard from "./HypedropLeaderboard";
import StakeLeaderboard from "./StakeLeaderboard";
import CsbattleLeaderboard from "./CsbattleLeaderboard";
import CsgogemLeaderboard from "./CsgogemLeaderboard";

const LeaderboardIndex = ({showMinimalDetails}) => {

    const location = useLocation();
    const [minimalDetails, setDetailsLevel] = useState(false);

    useEffect(() => {
        if(showMinimalDetails){
            setDetailsLevel(showMinimalDetails);
        }else{
            setDetailsLevel(false);
        }
    }, [showMinimalDetails]);

    return (
        <div className={`leaderboardBackdrop ${minimalDetails ? "min" : ""}`}>
            <div className={`container`}>

                <div className="leaderboardHeader">

                    <img src={leaderboardHeader} alt=""/>

                    <div className="leaderboardSwitcher">
                        {/*<NavLink className="leaderboardRoobet" to="" end>*/}
                        {/*    <img src={logoShuffle} alt=""/>*/}
                        {/*</NavLink>*/}
                        {/*<NavLink className="leaderboardCases" to="cases" end>*/}
                        {/*    <img src={logoCases} alt=""/>*/}
                        {/*</NavLink>*/}
                        {/*<NavLink className="leaderboardPackdraw" to="packdraw">*/}
                        {/*    <img src={logoPackdraw} alt=""/>*/}
                        {/*</NavLink>*/}
                        {/*<NavLink className="leaderboardClash" to="clash">*/}
                        {/*    <img src={logoClash} alt=""/>*/}
                        {/*</NavLink>*/}
                        <NavLink className="leaderboardStake" to="/leaderboard/stake">
                            <img src={logoStake} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>
                        </NavLink>
                        <NavLink className="leaderboardLuxdrop" to="/leaderboard/luxdrop" >
                            <img src={logoLuxdrop} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>
                        </NavLink>
                        <NavLink className="leaderboardRoll" to="/leaderboard/csgo-roll">
                            <img src={logoRoll} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>
                        </NavLink>
                        <NavLink className="leaderboardHypedrop" to="/leaderboard/hypedrop">
                            <img src={logoHypedrop} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>
                        </NavLink>
                        {/*<NavLink className="leaderboardCsbattle" to="/leaderboard/csbattle">*/}
                        {/*    <img src={logoCsbattle} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>*/}
                        {/*</NavLink>*/}
                        {/*<NavLink className="leaderboardCsgogem" to="/leaderboard/csgogem">*/}
                        {/*    <img src={logoCsgogem} alt="" style={{height: '32px', width: 'auto', maxWidth: '100%', objectFit: 'contain'}}/>*/}
                        {/*</NavLink>*/}
                    </div>

                </div>

                <div>
                    <Routes location={location}>
                        {/*<Route path="" element={<ShuffleLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        {/*<Route path="shuffle" element={<ShuffleLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        {/*<Route path="cases" element={<CasesLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        {/*<Route path="packdraw" element={<PackdrawLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        {/*<Route path="clash" element={<ClashLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        <Route path="luxdrop" element={<LuxdropLeaderboard showMinimalDetails={minimalDetails}/>}/>
                        <Route path="csgo-roll" element={<RollLeaderboard showMinimalDetails={minimalDetails}/>}/>
                        <Route path="hypedrop" element={<HypedropLeaderboard showMinimalDetails={minimalDetails}/>}/>
                        <Route path="stake" element={<StakeLeaderboard showMinimalDetails={minimalDetails}/>}/>
                        {/*<Route path="csbattle" element={<CsbattleLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                        {/*<Route path="csgogem" element={<CsgogemLeaderboard showMinimalDetails={minimalDetails}/>}/>*/}
                    </Routes>
                </div>


            </div>

        </div>
    );
}

export default LeaderboardIndex;
